module.exports = __webpack_public_path__ + "static/img/ls32.dedd960.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls32.png
// module id = 8H9/
// module chunks = 12